import {
	ToggleTrackBaseStyles,
	ToggleBaseStyles,
	ToggleTrack,
	ToggleCircleStyles,
	ToggleTrackInnerLabelStyles,
	ToggleInnerLabelStyles,
	ToggleLabelStyles,
} from './styles';
import { IDummyProps } from './types';
import { getHTMLAttributes } from '../../Utilities/utils/Funtions/data-aria-attrs';
import { CheckboxOverrides } from 'baseui/checkbox';
import { getBaseCustomProps, getFormCustomProps } from '../../Utilities/types/SharedProps';
import { StyleObject } from 'styletron-standard';
import * as meta from '../../meta-data.json';

export const overrides = (props: IDummyProps): CheckboxOverrides => {
	const HTMLAttrs = getHTMLAttributes(props);
	return {
		Root: {
			style: ToggleBaseStyles,
			props: {
				'data-epo': `epo-toggle-${meta.version}`,
				part: `epo-toggle-${meta.version}`,
				...HTMLAttrs.dataProps,
				className: props.className,
				...getBaseCustomProps(props),
			},
		},
		Input: {
			props: {
				id: props.id,
				...HTMLAttrs.ariaProps,
				...getFormCustomProps(props),
			},
		},
		Label: {
			// TODO see if we can remove this
			// props: {
			// 	$as: 'span',
			// },
			style: props => {
				return ToggleLabelStyles(props);
			},
		},
		ToggleInner: {
			// TODO see if we can remove this
			// props: {
			// 	$as: 'span',
			// },
		},
		Toggle: {
			style: ({ $theme, $error, $checked, $isHovered, $isFocused }: any) => {
				const styles = ToggleCircleStyles(
					{ $theme, $error, $checked, $isHovered, $isFocused },
					props.toggleSize,
				) as StyleObject;
				return {
					...styles,
					...ToggleInnerLabelStyles({ $theme, $error, $checked, $isFocused }, props),
				};
			},
			// TODO see if we can remove this
			// props: {
			// 	$as: 'span',
			// },
		},
		ToggleTrack: {
			style: ({ $theme, $checked, $isHovered, $error, $disabled, $isFocused }: any) => {
				let toggleProps = {};
				toggleProps = ToggleTrack($theme, $isHovered, $error, $checked, $disabled, $isFocused);
				return {
					...toggleProps,
					...ToggleTrackBaseStyles(props),
					...(props.innerLabels
						? ToggleTrackInnerLabelStyles({ $theme, $checked, $isHovered, $error, $disabled }, props)
						: {}),
				};
			},
			props: {
				$as: 'span',
			},
		},
	};
};
